export const categories = [
  {
    slug: 'dongzuo',
    name: '动作片',
    description: '热血沸腾的动作大片，燃爆全场',
    icon: 'ri-sword-line',
    image: 'https://readdy.ai/api/search-image?query=Action%20movie%20cinematic%20scene%20with%20explosive%20stunts%2C%20dramatic%20lighting%2C%20urban%20cityscape%20background%2C%20dark%20moody%20atmosphere%2C%20professional%20film%20color%20grading%2C%20warm%20orange%20and%20teal%20tones%2C%20movie%20poster%20style%20photography%2C%20high%20production%20value&width=800&height=450&seq=cat-dongzuo&orientation=landscape',
  },
  {
    slug: 'xiju',
    name: '喜剧片',
    description: '欢乐不断，笑料百出的精彩喜剧',
    icon: 'ri-emotion-laugh-line',
    image: 'https://readdy.ai/api/search-image?query=Comedy%20film%20vibrant%20scene%20with%20bright%20colorful%20lighting%2C%20happy%20playful%20atmosphere%2C%20warm%20sunny%20background%2C%20cinematic%20composition%20with%20soft%20bokeh%2C%20professional%20movie%20aesthetic%2C%20cheerful%20golden%20hour%20tones&width=800&height=450&seq=cat-xiju&orientation=landscape',
  },
  {
    slug: 'juqing',
    name: '剧情片',
    description: '深度剧情，触动心灵的感人故事',
    icon: 'ri-heart-line',
    image: 'https://readdy.ai/api/search-image?query=Emotional%20drama%20film%20scene%20with%20soft%20warm%20lighting%2C%20intimate%20character%20moment%2C%20shallow%20depth%20of%20field%2C%20gentle%20color%20palette%20of%20rose%20and%20cream%2C%20cinematic%20film%20look%2C%20meaningful%20storytelling%20atmosphere&width=800&height=450&seq=cat-juqing&orientation=landscape',
  },
  {
    slug: 'kehuan',
    name: '科幻片',
    description: '超乎想象的科幻世界，震撼视觉',
    icon: 'ri-rocket-line',
    image: 'https://readdy.ai/api/search-image?query=Futuristic%20sci-fi%20movie%20scene%20with%20neon%20lights%2C%20cyberpunk%20cityscape%2C%20advanced%20technology%20aesthetic%2C%20cool%20silver%20and%20cyan%20tones%2C%20cinematic%20wide%20shot%2C%20immersive%20atmosphere%2C%20high%20production%20value&width=800&height=450&seq=cat-kehuan&orientation=landscape',
  },
  {
    slug: 'kongbu',
    name: '恐怖片',
    description: '惊悚刺激，肾上腺素飙升的体验',
    icon: 'ri-ghost-line',
    image: 'https://readdy.ai/api/search-image?query=Horror%20film%20atmospheric%20scene%20with%20dim%20moody%20lighting%2C%20dark%20shadows%2C%20ominous%20composition%2C%20deep%20rich%20blacks%20and%20subdued%20red%20accents%2C%20suspenseful%20cinematic%20photography%2C%20haunting%20aesthetic&width=800&height=450&seq=cat-kongbu&orientation=landscape',
  },
  {
    slug: 'donghua',
    name: '动画片',
    description: '精美动画，全家共享的视听盛宴',
    icon: 'ri-movie-line',
    image: 'https://readdy.ai/api/search-image?query=Animated%20film%20beautiful%20scene%20with%20vibrant%20colors%2C%20whimsical%20storybook%20atmosphere%2C%20warm%20golden%20lighting%2C%20artistic%20composition%2C%20cinematic%20quality%2C%20soft%20dreamy%20background%2C%20charming%20visual%20style&width=800&height=450&seq=cat-donghua&orientation=landscape',
  },
  {
    slug: 'aiqing',
    name: '爱情片',
    description: '浪漫唯美，甜蜜动人的爱情故事',
    icon: 'ri-heart-pulse-line',
    image: 'https://readdy.ai/api/search-image?query=Romance%20film%20beautiful%20scene%20with%20soft%20warm%20sunset%20lighting%2C%20dreamy%20atmosphere%2C%20golden%20hour%20tones%2C%20cinematic%20composition%2C%20romantic%20vibe%2C%20elegant%20aesthetic%2C%20film%20color%20grading&width=800&height=450&seq=cat-aiqing&orientation=landscape',
  },
  {
    slug: 'jilu',
    name: '纪录片',
    description: '真实记录，探索世界的精彩纪录',
    icon: 'ri-camera-lens-line',
    image: 'https://readdy.ai/api/search-image?query=Documentary%20film%20scene%20with%20natural%20lighting%2C%20authentic%20real-world%20setting%2C%20earthy%20warm%20tones%2C%20cinematic%20composition%2C%20professional%20nature%20photography%20style%2C%20immersive%20atmosphere%2C%20storytelling%20aesthetic&width=800&height=450&seq=cat-jilu&orientation=landscape',
  },
];

export const articles = [
  {
    id: '1',
    title: '2026年最值得期待的十部动作大片',
    category: 'dongzuo',
    categoryName: '动作片',
    summary: '2026年动作片市场精彩纷呈，从超级英雄到谍战特工，从硬核格斗到科幻动作，各类大片轮番上阵。本文为您盘点年度最受期待的动作电影。',
    content: '<p>2026年，动作电影市场迎来了前所未有的繁荣。各大制片厂纷纷推出重磅作品，从经典系列的续集到全新的原创IP，每一部都令人期待。</p><h3>一、超级英雄类</h3><p>超级英雄电影依然是市场的主流。今年有多部令人瞩目的超英大片即将上映，特效水平持续升级，剧情深度也在不断提升。</p><h3>二、谍战特工类</h3><p>特工谍战题材一直是动作片的重要分支。今年有几部重量级特工电影定档，紧张刺激的追逐场面和精心设计的动作戏令人期待。</p><h3>三、硬核格斗类</h3><p>纯粹的格斗动作片今年也有不少亮点。多部影片邀请了世界顶级动作指导参与，力求呈现最真实震撼的打斗场面。</p><p>以上是2026年最值得期待的动作大片盘点，更多精彩内容请持续关注91片。</p>',
    publishDate: '2026-08-01',
    readTime: '8分钟',
    image: 'https://readdy.ai/api/search-image?query=Epic%20action%20movie%20collection%20poster%20wall%20with%20dynamic%20composition%2C%20dramatic%20lighting%2C%20warm%20orange%20and%20dark%20contrast%20tones%2C%20cinematic%20movie%20poster%20style%2C%20high%20production%20value%2C%20professional%20film%20aesthetic&width=1200&height=675&seq=article-1&orientation=landscape',
  },
  {
    id: '2',
    title: '经典喜剧电影推荐：笑中带泪的十部佳作',
    category: 'xiju',
    categoryName: '喜剧片',
    summary: '喜剧电影不仅仅是让人发笑，好的喜剧往往在欢乐中蕴含深意。本文精选十部经典喜剧电影，每一部都值得反复品味。',
    content: '<p>喜剧电影的魅力在于它能让观众在轻松愉快的氛围中感受生活的美好。以下是91片为您精选的十部经典喜剧佳作。</p><h3>笑中带泪的经典</h3><p>真正优秀的喜剧不仅是让人发笑，更能在欢笑之余引发思考。这些电影用幽默的方式讲述深刻的故事。</p><p>无论您是想放松心情还是寻找灵感，这些喜剧电影都不会让您失望。快来91片观看这些经典作品吧。</p>',
    publishDate: '2026-07-28',
    readTime: '6分钟',
    image: 'https://readdy.ai/api/search-image?query=Classic%20comedy%20film%20collage%20with%20bright%20cheerful%20colors%2C%20warm%20lighting%2C%20playful%20cinematic%20composition%2C%20movie%20poster%20aesthetic%2C%20happy%20vibrant%20atmosphere%2C%20professional%20film%20photography&width=1200&height=675&seq=article-2&orientation=landscape',
  },
  {
    id: '3',
    title: '科幻电影进化史：从经典到未来的视觉革命',
    category: 'kehuan',
    categoryName: '科幻片',
    summary: '科幻电影的发展史就是一部视觉特效的进化史。从早期的模型拍摄到如今的CGI技术，让我们一起回顾科幻电影的辉煌历程。',
    content: '<p>科幻电影作为最具想象力的电影类型之一，一直在推动电影技术的前进。从黑白默片时代到如今的数字特效时代，科幻电影走过了漫长而精彩的历程。</p><h3>黄金时代</h3><p>二十世纪中后期是科幻电影的黄金时代，诞生了无数经典之作，确立了科幻电影的基本范式。</p><h3>数字革命</h3><p>进入数字时代后，科幻电影的视觉效果实现了质的飞跃，让更宏大的世界观得以呈现在银幕上。</p><p>91片为您收录了各个时代的经典科幻作品，带您领略科幻电影的魅力。</p>',
    publishDate: '2026-07-25',
    readTime: '10分钟',
    image: 'https://readdy.ai/api/search-image?query=Futuristic%20sci-fi%20film%20evolution%20timeline%20visual%20with%20neon%20and%20silver%20tones%2C%20cyberpunk%20aesthetic%20mixed%20with%20classic%20space%20opera%2C%20cinematic%20composition%2C%20professional%20grade%20film%20imagery&width=1200&height=675&seq=article-3&orientation=landscape',
  },
  {
    id: '4',
    title: '国产剧情片崛起：近年口碑最佳的五部作品',
    category: 'juqing',
    categoryName: '剧情片',
    summary: '国产剧情片近年来质量持续提升，多部作品在国内外获得高度认可。本文盘点五部口碑爆棚的国产剧情片。',
    content: '<p>近年来，国产剧情片呈现出蓬勃发展的态势。从现实题材到历史故事，国产导演们用镜头讲述着动人的中国故事。</p><p>这些作品不仅在国内获得了观众的认可，也在国际电影节上屡获殊荣。91片为您整理了其中最值得观看的五部佳作。</p>',
    publishDate: '2026-07-20',
    readTime: '7分钟',
    image: 'https://readdy.ai/api/search-image?query=Chinese%20drama%20film%20aesthetic%20with%20warm%20earthy%20tones%2C%20cinematic%20composition%2C%20emotional%20storytelling%20atmosphere%2C%20beautiful%20natural%20lighting%2C%20professional%20film%20photography%2C%20artistic%20production%20value&width=1200&height=675&seq=article-4&orientation=landscape',
  },
  {
    id: '5',
    title: '恐怖片推荐：十部让你彻夜难眠的惊悚佳作',
    category: 'kongbu',
    categoryName: '恐怖片',
    summary: '恐怖片是电影中最具冲击力的类型之一。本文精选十部精品恐怖片，从心理惊悚到超自然恐怖，总有一部适合你。',
    content: '<p>恐怖电影的魔力在于它能调动观众最原始的情感反应。好的恐怖片不仅是吓人，更在叙事和氛围营造上展现出高超的艺术水准。</p><p>91片为您精选了十部不同风格的恐怖佳作，请做好心理准备后再观看。</p>',
    publishDate: '2026-07-18',
    readTime: '6分钟',
    image: 'https://readdy.ai/api/search-image?query=Horror%20film%20atmospheric%20collage%20with%20dark%20moody%20lighting%2C%20deep%20shadows%2C%20cinematic%20suspense%20composition%2C%20haunting%20aesthetic%2C%20rich%20black%20tones%20with%20subtle%20red%20accents%2C%20professional%20film%20photography&width=1200&height=675&seq=article-5&orientation=landscape',
  },
  {
    id: '6',
    title: '年度动画电影大盘点：全家共享的精彩世界',
    category: 'donghua',
    categoryName: '动画片',
    summary: '2026年的动画电影市场百花齐放，从3D动画巨制到精美手绘作品，每部都给观众带来独特的视觉享受。',
    content: '<p>动画电影早已不只是儿童专属。今年上映的动画作品涵盖了全年龄段，技术和艺术水准都达到了新的高度。</p><p>91片盘点了2026年最值得观看的动画电影，快来看看有没有您期待的作品。</p>',
    publishDate: '2026-07-15',
    readTime: '5分钟',
    image: 'https://readdy.ai/api/search-image?query=Animated%20film%20colorful%20collection%20with%20vibrant%20whimsical%20style%2C%20dreamy%20atmosphere%2C%20warm%20golden%20lighting%2C%20cinematic%20quality%2C%20artistic%20beautiful%20composition%2C%20enchanting%20visual%20aesthetic&width=1200&height=675&seq=article-6&orientation=landscape',
  },
  {
    id: '7',
    title: '恋爱电影推荐：七部让你心动的浪漫佳作',
    category: 'aiqing',
    categoryName: '爱情片',
    summary: '爱情是最永恒的电影主题之一。本文精选七部风格各异的爱情电影，涵盖经典与当代，总有一部能打动你的心。',
    content: '<p>爱情电影用最温柔的方式讲述人与人之间最美好的情感。从青涩的初恋到成熟的相伴，每一个故事都触动人心。</p><p>91片为您整理了七部不容错过的爱情电影，在这个季节感受爱的温度。</p>',
    publishDate: '2026-07-12',
    readTime: '5分钟',
    image: 'https://readdy.ai/api/search-image?query=Romance%20film%20beautiful%20collage%20with%20soft%20sunset%20lighting%2C%20dreamy%20atmosphere%2C%20golden%20warm%20tones%2C%20cinematic%20romantic%20composition%2C%20elegant%20aesthetic%2C%20professional%20film%20photography&width=1200&height=675&seq=article-7&orientation=landscape',
  },
  {
    id: '8',
    title: '自然纪录片精选：五部震撼心灵的地球故事',
    category: 'jilu',
    categoryName: '纪录片',
    summary: '优秀的自然纪录片能让我们足不出户领略地球的壮美。本文推荐五部制作精良的自然纪录片，带你领略大自然的魅力。',
    content: '<p>自然纪录片是人类探索世界的窗口。通过精湛的摄影技术和耐心的等待，纪录片团队为我们展现了地球上最震撼的画面。</p><p>91片精选了五部高分自然纪录片，每一帧都是壁纸级别的画面。</p>',
    publishDate: '2026-07-10',
    readTime: '7分钟',
    image: 'https://readdy.ai/api/search-image?query=Nature%20documentary%20film%20stunning%20landscape%20with%20natural%20lighting%2C%20earthy%20warm%20tones%2C%20cinematic%20wide%20composition%2C%20professional%20wildlife%20photography%2C%20immersive%20atmosphere%2C%20awe-inspiring%20visual&width=1200&height=675&seq=article-8&orientation=landscape',
  },
  {
    id: '9',
    title: '2026上半年必看电影榜单TOP20',
    category: 'dongzuo',
    categoryName: '动作片',
    summary: '2026年已经过半，上半年有哪些电影值得一看？91片为您整理了上半年评分最高的20部电影榜单。',
    content: '<p>2026年上半年，电影市场呈现出丰富多元的态势。从商业大片到文艺佳作，都给观众带来了不同的观影体验。</p><p>以下是91片根据评分和口碑整理的2026上半年TOP20电影榜单，排名不分先后。</p>',
    publishDate: '2026-07-05',
    readTime: '12分钟',
    image: 'https://readdy.ai/api/search-image?query=Movie%20award%20ceremony%20elegant%20scene%20with%20warm%20golden%20lighting%2C%20cinematic%20composition%2C%20prestigious%20atmosphere%2C%20professional%20film%20photography%2C%20luxurious%20venue%2C%20star-studded%20feel&width=1200&height=675&seq=article-9&orientation=landscape',
  },
  {
    id: '10',
    title: '暑期档喜剧合集：全家欢乐之选',
    category: 'xiju',
    categoryName: '喜剧片',
    summary: '暑期档是喜剧电影扎堆上映的黄金时期。本文为您盘点暑期档最值得关注的喜剧新片。',
    content: '<p>炎炎夏日，走进影院看一部轻松愉快的喜剧电影是再好不过的选择。今年暑期档有多部喜剧新片上映。</p><p>91片为您整理了暑期档的喜剧片单，带上家人朋友一起欢笑吧。</p>',
    publishDate: '2026-07-02',
    readTime: '4分钟',
    image: 'https://readdy.ai/api/search-image?query=Summer%20comedy%20film%20festival%20with%20bright%20sunny%20lighting%2C%20colorful%20playful%20atmosphere%2C%20cinematic%20wide%20composition%2C%20cheerful%20vibrant%20aesthetic%2C%20professional%20film%20photography&width=1200&height=675&seq=article-10&orientation=landscape',
  },
  {
    id: '11',
    title: '深度解析：科幻电影中的AI主题变迁',
    category: 'kehuan',
    categoryName: '科幻片',
    summary: '人工智能一直是科幻电影的热门主题。从早期的机器人恐惧到如今对AI伦理的探讨，科幻电影中的AI形象经历了怎样的变迁？',
    content: '<p>AI主题在科幻电影中由来已久。随着现实世界中AI技术的快速发展，电影中的AI形象也在不断演变。</p><p>本文将从电影史的角度，深入分析科幻电影中AI主题的变迁轨迹。</p>',
    publishDate: '2026-06-28',
    readTime: '9分钟',
    image: 'https://readdy.ai/api/search-image?query=AI%20themed%20sci-fi%20film%20concept%20art%20with%20futuristic%20digital%20aesthetic%2C%20cool%20silver%20and%20blue%20tones%2C%20cinematic%20composition%2C%20artificial%20intelligence%20representation%2C%20professional%20film%20photography&width=1200&height=675&seq=article-11&orientation=landscape',
  },
  {
    id: '12',
    title: '小众剧情片推荐：被忽视的年度佳作',
    category: 'juqing',
    categoryName: '剧情片',
    summary: '在商业大片之外，很多优秀的小众剧情片值得关注。本文推荐几部可能被您忽略的好片。',
    content: '<p>每年的电影节上都会涌现出许多优秀的独立制作剧情片，但由于宣发预算有限，很多好片并没有得到应有的关注。</p><p>91片为您挖掘这些被埋没的佳作，希望更多人能看到这些用心的作品。</p>',
    publishDate: '2026-06-25',
    readTime: '6分钟',
    image: 'https://readdy.ai/api/search-image?query=Independent%20film%20festival%20atmosphere%20with%20warm%20intimate%20lighting%2C%20artistic%20cinematic%20composition%2C%20earthy%20rich%20tones%2C%20professional%20film%20photography%2C%20cultural%20storytelling%20aesthetic&width=1200&height=675&seq=article-12&orientation=landscape',
  },
];

export const featuredArticles = ['1', '3', '5', '7'];

export const siteInfo = {
  name: '91片',
  tagline: '正版资源一站直达',
  description: '91片是国内领先的视频内容平台，提供海量正版高清资源，极速播放、安全稳定。我们致力于为用户打造最佳的在线观影体验。',
  foundedYear: 2018,
  totalUsers: 50000000,
  totalContent: 200000,
  dailyActive: 8000000,
  email: 'contact@91pian.com',
  phone: '400-888-9191',
  address: '北京市朝阳区建国路88号SOHO现代城A座',
  socialLinks: {
    weibo: 'https://weibo.com/91pian',
    wechat: '91pian_official',
  },
};

export const faqs = [
  {
    question: '91片平台是否需要付费？',
    answer: '91片平台提供海量免费内容供用户观看。部分最新院线大片和高清独家内容可能需要会员付费，但我们的免费内容库已经非常丰富，足以满足大多数用户的观影需求。',
  },
  {
    question: '如何在91片上找到我想看的内容？',
    answer: '您可以通过91片首页的搜索功能直接搜索片名，也可以按照分类浏览。我们还有智能推荐系统，会根据您的观看历史为您推荐感兴趣的内容。',
  },
  {
    question: '91片的视频播放画质如何？',
    answer: '91片支持从标清到超高清4K的多种画质选择。系统会根据您的网络状况自动选择最佳画质，您也可以在播放器设置中手动调整。',
  },
  {
    question: '91片支持哪些设备观看？',
    answer: '91片支持PC端网页、手机浏览器、平板等多种设备访问。我们的网站采用响应式设计，在任何设备上都能获得良好的观看体验。',
  },
  {
    question: '91片的内容更新频率是怎样的？',
    answer: '91片每天都会更新最新内容，包括新片上线、经典老片加更等。您可以在首页的"最新内容"板块查看每日更新。',
  },
  {
    question: '遇到播放问题怎么办？',
    answer: '如果您在播放过程中遇到卡顿、无法加载等问题，建议先检查网络连接，尝试切换画质或刷新页面。如问题持续存在，请联系我们的客服团队获取帮助。',
  },
];

export const milestones = [
  { year: '2018', title: '平台创立', description: '91片正式上线，开启视频内容平台之旅' },
  { year: '2019', title: '用户突破1000万', description: '凭借优质内容快速积累用户，成为行业新星' },
  { year: '2020', title: '4K超清上线', description: '率先支持4K超高清播放，提升用户观影体验' },
  { year: '2021', title: '内容突破10万+', description: '正版内容库突破10万，覆盖全类型影片' },
  { year: '2022', title: '用户突破3000万', description: '用户规模持续增长，平台影响力不断扩大' },
  { year: '2023', title: 'AI智能推荐', description: '上线AI智能推荐系统，精准匹配用户喜好' },
  { year: '2024', title: '全球化布局', description: '拓展海外市场，内容覆盖更广泛的用户群体' },
  { year: '2025', title: '用户突破5000万', description: '注册用户超过5000万，日活跃用户800万+' },
];